<template>
    <div>
        <h1 style="text-align: center;">Sliders Component Editor</h1>
        <div v-if="isLoading" class="loading">PLEASE WAIT...</div>
        <div>
            <div ref="cntTitle">
                <h2>Title</h2>
                <div><input type="text" v-model="title" style="width: 100%"></div>
            </div>
            <div ref="cntThumb">
                <h2>Thumbnail</h2>
                <div><img :src="thumbnail.data" height="200px" width="100%" style="object-fit: contain;"></div>
                <div><input type="file" ref="thumbsel" v-on:change="changeImage(thumbnail, 'thumbsel')" accept="image/jpeg,image/png,image/tif" style="width: 100%; color: black;"></div>
            </div>
            <hr>
            <div v-for="(box, i) in data" :key="'cntBox' + i">
                <div :ref="'cntEntry' + i">
                    <input type="text" v-model="box.thenTxt" placeholder="Then Text" style="width:33%">
                    <input type="text" v-model="box.sliderTxt" placeholder="Slider Text" style="width:33%">
                    <input type="text" v-model="box.nowTxt" placeholder="Now Text" style="width:33%">
                </div>
                <div>
                    <button @click="deleteBox(i)" style="width: 100%; font-size: 1.2em; background: maroon; color: white;">Delete This</button>
                </div>
                <hr>
            </div>
            <div>
                <button @click="addNew()" class="submit-btn">Add New Slider Entry</button>
                <button @click="submitThis()" class="submit-btn">Submit</button>
                <hr>
            </div>
        </div>
    </div>
</template>

<style scoped>
textarea{
    width: 100%;
}
    .quill-editor{
        background: white;
        color: black;
    }
    .ql-container.ql-snow{
        background: white !important;
    }
    .submit-btn{
        width: 100%;
        height: 2em;
        font-size: 1.5em;
        font-weight: 800;
        margin-top: 0.5em;
    }
    .has-error{
        border: red 5px solid;
        box-sizing: border-box;
    }
    .has-error::after{
        content: "Missing content/invalid content.";
        color: red;
        background: white;
        font-weight: 800;
    }
    hr{
        border: solid 2px white;
    }
    h2{
      color: black;
    }
    .loading{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        vertical-align: middle;
        justify-content: center;
        text-align: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: flex;
        font-size: 4em;
        font-weight: 900;
    }
</style>

<script>
import {Functions} from './functions.js';
export default {
    name: "GalleryAddEditComponent",
    props: ["ID"],
    data: () => ({
        isLoading: true,
        title: "",
        id: undefined,
        data: [],
        thumbnail: {
            file: undefined,
            data: "",
            publicUrl: "",
            uploadUrl: ""
        },
        functions: undefined,
        buffer: undefined
    }),
    mounted: function(){
        this.functions = new Functions();
        if(this.ID){
            console.log("EDITING");
            
            this.functions.getComponent(this.ID, (data) => {
                console.log(data);
                this.id = data.contentId;
                this.title = data.title;
                this.data = data.data.sliders;
                this.thumbnail.publicUrl = data.rdsDat[0].Thumbnail;
                this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "getObject", (thumbBuff) => {
                    this.thumbnail.data = (thumbBuff.signedUrl);
                    this.functions.getSignedUrl("ttedu-static", data.rdsDat[0].Thumbnail, "image/jpeg,image/png,image/tif", "putObject", (thumbBuff1) => {
                        this.thumbnail.uploadUrl = thumbBuff1.signedUrl;
                        this.isLoading = false;
                    });
                });
            });
        }else{
            console.log("Create New");
            
            this.functions.getThumbURL((dat) => {
                this.thumbnail.publicUrl = dat.key;
                this.thumbnail.uploadUrl = dat.signedUrl;
                this.addNew();
            });
        }
    },
    methods: {
        addNew: function(){
            this.isLoading = true;
            this.data.push({
                thenTxt: "",
                nowTxt: "",
                sliderTxt: "",
                ID: this.data.length + 1
            });
            this.data.forEach((d,i) => d.ID = i+1);
            this.isLoading = false;
        },
        deleteBox: function(i){
            let c = confirm("Are you sure you want to delete Entry #" + (i+1));
            if(c){
                this.data.splice(i, 1);
                this.data.forEach((d,i) => d.ID = i+1);
            }
        },
        changeImage: function(img, selref){
            var reader = new FileReader();
            reader.onload = (e) => {
                img.data = e.target.result;
            }
            if(this.$refs[selref].length){
                reader.readAsDataURL(this.$refs[selref][0].files[0]);
                img.file = this.$refs[selref][0].files[0];
            }else{
                reader.readAsDataURL(this.$refs[selref].files[0]);
                img.file = this.$refs[selref].files[0];
            }
        },
        submitThis: function(){
            if(this.ID){
                this.UpdateEntry();
            }else{
                this.CreateNew();
            }
        },
        UpdateEntry: function(){
            this.isLoading = true;
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error");
            if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
            else this.$refs.cntThumb.classList.remove("has-error");
            if(this.data.length == 0){alert("No slider entries available, select minimum 1"); hasError = true;}

            this.data.forEach((entry, i) => {
                if(entry.thenTxt.trim() == "" || entry.nowTxt.trim() == "" || entry.sliderTxt.trim() == ""){
                    this.$refs["cntEntry" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntEntry" + i][0].classList.remove("has-error");
                }
            });
            
            if(!hasError){
                console.log("Sending data to server here");

                var componentData = {
                    ContentType: "INTERACTIVE",
                    Title: this.title,
                    Thumbnail: this.thumbnail.publicUrl,
                    Component: "infographic2",
                    Data: {
                            title: this.title,
                            sliders: this.data
                    }
                };
                console.log("1");
                this.functions.updateComponent(this.ID, componentData,(dat) => {
                    console.log(dat);
                    if(this.thumbnail.file != undefined){
                        this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                            console.log(dat);
                            this.$router.push("/editors/component/infographic2");
                        });
                    }else{
                        this.$router.push("/editors/component/infographic2");
                    }
                });
            }
        },
        CreateNew: function(){
            this.isLoading = true;
            let hasError = false;
            if(this.title.trim() == "") {this.$refs.cntTitle.classList.add("has-error"); hasError = true;}
            else this.$refs.cntTitle.classList.remove("has-error");
            if(this.thumbnail.file == undefined) {this.$refs.cntThumb.classList.add("has-error"); hasError = true;}
            else this.$refs.cntThumb.classList.remove("has-error");
            if(this.data.length == 0){alert("No slider entries available, select minimum 1"); hasError = true;}

            this.data.forEach((entry, i) => {
                if(entry.thenTxt.trim() == "" || entry.nowTxt.trim() == "" || entry.sliderTxt.trim() == ""){
                    this.$refs["cntEntry" + i][0].classList.add("has-error");
                    hasError = true;
                }else{
                    this.$refs["cntEntry" + i][0].classList.remove("has-error");
                }
            });

            if(!hasError){
                console.log("Sending data to server here");
                
                var componentData = {
                    ContentType: "INTERACTIVE",
                    Title: this.title,
                    Thumbnail: this.thumbnail.publicUrl,
                    Component: "infographic2",
                    Data: {
                        title: this.title,
                        sliders: this.data
                    }
                };

                console.log(componentData);

                this.functions.upload(this.thumbnail.uploadUrl, this.thumbnail.file, (dat) => {
                    this.functions.addComponent(componentData,(dat) => {
                        console.log(dat);
                        this.$router.push("/editors/component/infographic2");
                    });
                });
            }
        }
    }
}
</script>